import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { reduxForm, change as changeFieldValue } from "redux-form";

import WizardFooter from "./WizardFooter";
import TextInput from "./TextInput";
import HelpBubble from "./HelpBubble";

export const fields = ["first_name", "last_name", "email"];
const validate = (values, props) => {
  const errors = {};
  ["first_name", "last_name", "email"].forEach(field => {
    if (!values[field]) {
      errors[field] = props.allText.shared.required;
    }

    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

    if (!values.email) {
      errors.email = props.allText.shared.required;
    } else if (!emailRegex.test(values.email)) {
      errors.email = props.allText.shared.invalid_email;
    }
  });
  return errors;
};

export class WizardFormIntro extends PureComponent {
  componentDidMount() {
    const {
      fields: { first_name, last_name, email },
      queryParams,
    } = this.props;
    if (queryParams.firstName) {
      first_name.autofill(queryParams.firstName);
    }
    if (queryParams.lastName) {
      last_name.autofill(queryParams.lastName);
    }
    if (queryParams.email) {
      email.autofill(queryParams.email);
    }
  }

  render() {
    const {
      allText,
      handleSubmit,
      onOptOut,
      fields: { first_name, last_name, email },
      logo,
    } = this.props;
    const text = Object.assign({}, allText.shared, allText.intro);
    return (
      <form onSubmit={handleSubmit} className="form-horizontal-intro">
        <div className="wizard-page-content">
          {/* <div className="page-top-information">{text.information01}</div> */}
          <div className="row page-title-container">
            <div className="col-12 col-md-10 col-lg-8 page-title">
              {text.title}
            </div>
          </div>
          <div className="wizard-text paragraph big">{text.paragraph01}</div>
          {/* <div className="wizard-text paragraph medium">{text.paragraph03}</div> */}
          <div className="row page-inputs">
            <div className="col-12 col-md-6 col-lg-4">
              <div className="wizard-text">{text.first_name}</div>
              <TextInput
                text={text}
                field={first_name}
                placeholder={text.first_name}
              />
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="wizard-text">{text.last_name}</div>
              <TextInput
                text={text}
                field={last_name}
                placeholder={text.last_name}
              />
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="wizard-text">{text.email}</div>
              <TextInput text={text} field={email} placeholder={text.email} />
            </div>
          </div>
          <div className="wizard-text paragraph small">{text.paragraph02}</div>

          <div className="row intro-bottom-paragraph">
            {/* <div className="col-12 order-last col-sm-4 order-sm-first"> */}
            <div
              className="page-bottom-left-information"
              onClick={handleSubmit(onOptOut)}
              style={{ marginLeft: "14px" }}
            >
              {text.information02}
            </div>
            {/* </div> */}
            <div className="col-12 col-sm-8 justify-content-center justify-content-sm-end right-information-container">
              <div className="text-left text-md-right page-bottom-right-information">
                <div className="page-bottom-right-information-text">
                  {text.rightBottomInformation01}
                </div>
                <div className="page-bottom-right-information-text">
                  {text.rightBottomInformation02}
                </div>
                <div className="page-bottom-right-information-text">
                  {text.rightBottomInformation03}
                </div>
              </div>
              <div className="help-bubble-container">
                <HelpBubble />
              </div>
            </div>
          </div>
        </div>
        <WizardFooter
          text={text}
          nextLabel={text.continue}
          intro={true}
          logo={logo}
        />
      </form>
    );
  }
}

WizardFormIntro.propTypes = {
  allText: PropTypes.object.isRequired,
  changeFieldValue: PropTypes.func,
  errors: PropTypes.object,
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onOptOut: PropTypes.func.isRequired,
  queryParams: PropTypes.object.isRequired,
  logo: PropTypes.string,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ changeFieldValue }, dispatch);
}

export default reduxForm(
  {
    form: "wizard",
    fields,
    destroyOnUnmount: false,
    validate,
  },
  null,
  mapDispatchToProps
)(WizardFormIntro);



// WEBPACK FOOTER //
// ./src/components/WizardFormIntro.js